import type { CustomFlowbiteTheme } from 'flowbite-react';

export const ratingTheme: CustomFlowbiteTheme['rating'] = {
  root: {
    base: 'flex items-center',
  },
  star: {
    empty: 'text-titan-night-300',
    filled: 'text-titan-yellow-400',
    sizes: {
      sm: 'w-5 h-5',
      md: 'w-7 h-7',
      lg: 'w-10 h-10',
    },
  },
};
